import { ChevronDown, Trash, Unlink } from 'lucide-react';

export function SearchIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <circle cx="7" cy="7" r="4.6" stroke="currentColor" strokeWidth="1.75" />
      <path d="M10.6 10.6L14 14" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}

export function PlusIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden>
      <path d="M7 2.5v9M2.5 7h9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function ChevronIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden style={{ color: 'rgba(var(--ink-rgb),0.4)' }}>
      <path d="M7 4l5 5-5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
      <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

// The three glyphs the connected card's DS Icon Buttons carry, at the Figma
// "Symphony Icon Button" spec (node 313:223): a 16px glyph on a 1.5px stroke.
// `absoluteStrokeWidth` is what holds that 1.5 at 16px — lucide's own scaling
// would thin it to 1.33. These were hand-drawn copies of these same lucide
// paths before, at three different weights.
const GLYPH = { size: 16, strokeWidth: 1.5, absoluteStrokeWidth: true, 'aria-hidden': true } as const;

export function TrashIcon() {
  return <Trash {...GLYPH} />;
}

export function UnlinkIcon() {
  return <Unlink {...GLYPH} />;
}

export function ChevronDownIcon() {
  return <ChevronDown {...GLYPH} />;
}
